module.exports = __webpack_public_path__ + "img/us_sczfgp.d0ddff91.png";